// actions.js
import { projectSlice } from "./reducers";
import { userSlice } from "./reducers/userSlice";

export const { addProject, updateProject, addSegment, addSegmentInfo, deleteProject, deleteProjectSegmentSuccess,deleteProjectSegment } = projectSlice.actions;
export const { userLogin, userLogout } = userSlice.actions;
